import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
console.log(window.location.hash,'111')
export default new Router({
  mode: window.location.hash ? 'hash' : 'history',
  routes: [
    {
      path: "/",
      name: "index",
      component: () => import("@/views/index")
    },
    {
      path: "/agreement",
      name: "",
      component: () => import("@/views/h5/agreement")
    },
    {
      path: "/spellGroupPlay",
      name: "拼团玩法",
      component: () => import("@/views/h5/spellGroupPlay")
    },
    {
      path: "/processDetails",
      name: "工艺详情",
      component: () => import("@/views/native/processDetails")
    },
    {
      path: "/customerServiceCenter",
      name: "平台客服",
      component: () => import("@/views/h5/customerServiceCenter")
    },
    {
      path: "/problemDetail",
      name: "查看解决方案",
      component: () => import("@/views/h5/problemDetail")
    },
    {
      path: "/revenueTrend",
      name: "收入趋势",
      component: () => import("@/views/h5/revenueTrend")
    },
    {
      path: "/disclosureItemDetails",
      name: "交底项详情",
      component: () => import("@/views/h5/disclosureItemDetails")
    },
    {
      path: "/caseDetails",
      name: "案例详情",
      component: () => import("@/views/h5/caseDetails")
    },
    {
      path: "/reviewRobSingle",
      name: "审核抢单",
      component: () => import("@/views/h5/reviewRobSingle")
    },
    {
      path: "/unifiedWages",
      name: "统一工价",
      component: () => import("@/views/h5/unifiedWages")
    },
    {
      path: "/djProcess",
      name: "当家工艺",
      component: () => import("@/views/h5/djProcess")
    },
    {
      path: "/wagesList",
      name: "工价列表",
      component: () => import("@/views/h5/wagesList")
    },
    {
      path: "/processTechnologyList",
      name: "工艺列表",
      component: () => import("@/views/h5/processTechnologyList")
    },
    {
      path: "/download",
      name: "当家商家",
      component: () => import("@/views/h5/download")
    },
    {
      path: "/historyGetMoneyRecords",
      name: "历史拿钱记录",
      component: () => import("@/views/h5/historyGetMoneyRecords")
    },
    {
      path: "/takeMoneyToDetail",
      name: "拿钱明细",
      component: () => import("@/views/h5/takeMoneyToDetail")
    },
    {
      path: "/craftsmanRegistered",
      name: "当家工匠注册申请",
      component: () => import("@/views/h5/craftsmanRegistered")
    },
    {
      path: "/registeredSuccess",
      name: "注册成功",
      component: () => import("@/views/h5/registeredSuccess")
    },
    {
      path: "/goGoodsDetails",
      name: "百万补贴计划 - 1元精算服务",
      component: () => import("@/views/h5/goGoodsDetails")
    },
    {
      path: "/h5LoginDemo",
      name: "h5触发小程序登陆",
      component: () => import("@/views/h5/h5LoginDemo")
    },
    {
      path: "/shareCoupons",
      name: "分享得券活动",
      component: () => import("@/views/h5/shareCoupons")
    },
    {
      path: "/callCraftsmanIntroduce",
      name: "免费呼个师傅 上门开清单",
      component: () => import("@/views/activity/callCraftsmanIntroduce")
    },
    {
      path: "/getDocumentContent",
      component: () => import("@/views/h5/getDocumentContent")
    },
    {
      path: "/warmPrompt",
      name: "温馨提示",
      component: () => import("@/views/h5/warmPrompt")
    },
    {
      path: "/djIntroductionMaterials",
      component: () => import("@/views/h5/djIntroductionMaterials")
    },
    {
      path: "/callSheet",
      name: "呼个师傅",
      component: () => import("@/views/h5/callSheet")
    },
    {
      path: "/callSheetReceivePrize",
      name: "呼个师傅",
      component: () => import("@/views/activity/callSheetReceivePrize")
    },
    {
      path: "/billingPlatformSubsidy",
      name: "开单领平台补贴",
      component: () =>
        import("@/views/activity/billingPlatformSubsidy/billingPlatformSubsidy")
    },
    {
      path: "/inviteFriendsToBill",
      name: "邀好友 赚奖励",
      component: () =>
        import(
          "@/views/activity/billingPlatformSubsidy/inviteFriendsToBill/index"
        )
    },
    {
      path: "/inviteFriendsToBill/reward",
      name: "我的奖励",
      component: () =>
        import(
          "@/views/activity/billingPlatformSubsidy/inviteFriendsToBill/reward"
        )
    },
    {
      path: "/inviteFriendsToBill/invite",
      name: "我的邀请",
      component: () =>
        import(
          "@/views/activity/billingPlatformSubsidy/inviteFriendsToBill/invite"
        )
    },
    {
      path: "/billingSubsidyLotteryRecord",
      name: "领取记录",
      component: () =>
        import(
          "@/views/activity/billingPlatformSubsidy/billingSubsidyLotteryRecord"
        )
    },

    {
      path: "/priceGuessing",
      name: "竞猜材料低价赢大奖",
      component: () => import("@/views/activity/priceGuessing/index")
    },
    {
      path: "/priceGuessing/ownerIndex",
      name: "竞猜材料低价赢大奖",
      component: () => import("@/views/activity/priceGuessing/ownerIndex")
    },
    {
      path: "/priceGuessing/success",
      name: "成功参与竞猜",
      component: () =>
        import("@/views/activity/priceGuessing/successfulParticipation")
    },
    {
      path: "/priceGuessing/result",
      name: "竞猜结果",
      component: () => import("@/views/activity/priceGuessing/result")
    },
    {
      path: "/priceGuessing/rule",
      name: "活动规则",
      component: () => import("@/views/activity/priceGuessing/rule")
    },
    {
      path: "/priceGuessing/chooseAPrize",
      name: "请选择中奖商品规格",
      component: () => import("@/views/activity/priceGuessing/chooseAPrize")
    },
    {
      path: "/h5/addAddress",
      name: "填写收货地址",
      component: () => import("@/views/h5/addAddress")
    },
    {
      path: "/craftsmanCertification",
      name: "工匠认证",
      component: () => import("@/views/h5/craftsmanCertification")
    },
    {
      path: "/findFileds",
      name: "findFileds",
      component: () => import("@/views/h5/findFileds")
    },
    {
      path: "/coupon/list",
      name: "当家日抢超级施工券",
      component: () => import("@/views/activity/coupon/list")
    },
    {
      path: "/activityCouponList",
      name: "",
      component: () => import("@/views/activity/coupon/activityCouponList")
    },
    {
      path: "/subsidy/tenMillionSubsidy",
      name: "当家千万补贴计划",
      component: () => import("@/views/activity/subsidy/tenMillionSubsidy")
    },
    {
      path: "/subsidy/tenMillionSubsidyFC",
      name: "当家千万补贴计划",
      component: () => import("@/views/activity/subsidy/tenMillionSubsidyFC")
    },
    {
      path: "/technologyAssessment",
      name: "工艺考核",
      component: () => import("@/views/h5/technologyAssessment")
    },
    {
      path: "/FAQView",
      name: "常见问题查看",
      component: () => import("@/views/h5/FAQView")
    },
    {
      path: "/listingIntroducedVideo",
      name: "清单介绍",
      component: () => import("@/views/h5/listingIntroducedVideo")
    },
    {
      path: "/chooseDJ",
      name: "平台介绍",
      component: () => import("@/views/h5/chooseDJ")
    },
    {
      path: "/UdeskWebIM",
      name: "IM",
      component: () => import("@/views/h5/UdeskWebIM")
    },
    {
      path: "/threeSharingActivities",
      name: "",
      component: () => import("@/views/activity/threeSharingActivities")
    },
    {
      path: "/threeSharingActivities/craftsmanSelectList",
      name: "分享工匠得好礼",
      component: () =>
        import("@/views/activity/threeSharingActivities/craftsmanSelectList")
    },
    {
      path: "/threeSharingActivities/reportSelectList",
      name: "分享验房报告得好礼",
      component: () =>
        import("@/views/activity/threeSharingActivities/reportSelectList")
    },
    {
      path: "/threeSharingActivities/detailedListSelectList",
      name: "分享清单得好礼",
      component: () =>
        import("@/views/activity/threeSharingActivities/detailedListSelectList")
    },
    {
      path: "/threeSharingActivities/shareOpenPage",
      name: "帮我点赞",
      component: () =>
        import("@/views/activity/threeSharingActivities/shareOpenPage")
    },
    {
      path: "/threeSharingActivities/activitiesList",
      name: "",
      component: () =>
        import("@/views/activity/threeSharingActivities/activitiesList")
    },
    {
      path: "/addAddress",
      name: "填写收货地址",
      component: () => import("@/views/publicPage/addAddress")
    },
    {
      path: "/threeSharingActivities/activityRecord",
      name: "活动记录",
      component: () =>
        import("@/views/activity/threeSharingActivities/activityRecord")
    },
    {
      path: "/sharedFissionActivity",
      name: "",
      component: () => import("@/views/activity/sharedFissionActivity/index")
    },
    {
      path: "/activityRule",
      name: "",
      component: () => import("@/views/h5/activityRule")
    },
    {
      path: "/getMyGifts",
      name: "领取礼品",
      component: () => import("@/views/h5/getMyGifts")
    },
    {
      path: "/shareGoodsToBuy",
      name: "分享好物得奖励",
      component: () => import("@/views/activity/shareGoodsToBuy/index")
    },
    {
      path: "/openLimitedTimePurchase",
      name: "打开限时购",
      component: () => import("@/views/native/openLimitedTimePurchase")
    },
    {
      path: "/understandingDJ",
      name: "一分钟了解当家装修",
      component: () => import("@/views/h5/understandingDJ")
    },
    {
      path: "/introductionPlatformServices",
      name: "平台服务介绍",
      component: () => import("@/views/h5/introductionPlatformServices")
    },
    {
      path: "/training",
      name: "培训计划通知",
      component: () => import("@/views/h5/training")
    },
    {
      path: "/cityCodeImg",
      name: "专属推广官",
      component: () => import("@/views/h5/cityCodeImg")
    },
    {
      path: "/maliciousOmissionProtection",
      name: "恶意漏项 免费施工保障",
      component: () => import("@/views/h5/maliciousOmissionProtection")
    },
    {
      path: "/renovation",
      name: "旧房重装",
      component: () => import("@/views/h5/renovation")
    },
    {
      path: "/partialRenovation",
      name: "局部改造",
      component: () => import("@/views/h5/partialRenovation")
    },
    {
      path: "/limitedTimePurchaseActivity",
      name: "限时抢购",
      component: () => import("@/views/activity/threeSharingActivities/limitedTimePurchaseActivity")
    },
    {
      path: "/homeSpecifications",
      name: "标准施工",
      component: () => import("@/views/h5/homeSpecifications")
    },
    {
      path: "/serviceSpecification",
      name: "服务规范",
      component: () => import("@/views/h5/serviceSpecification")
    },
    {
      path: "/serviceStandards",
      name: "严选工长工匠",
      component: () => import("@/views/h5/serviceStandards")
    },
    {
      path: "/serviceGuarantee",
      name: "全面保障",
      component: () => import("@/views/h5/serviceGuarantee")
    },
    {
      path: "/constructionLabourCost",
      name: "施工工价",
      component: () => import("@/views/h5/constructionLabourCost")
    },
    {
      path: "/customerServiceNative",
      name: "",
      component: () => import("@/views/native/customerServiceNative")
    },
    {
      path: "/toCmdPage",
      name: "",
      component: () => import("@/views/native/toCmdPage")
    },
    {
      path: "/miniprogramJump",
      name: "跳转小程序",
      component: () => import("@/views/h5/miniprogramJump")
    },
    {
      path: "/openMiniProgram",
      name: "当家APP",
      component: () => import("@/views/h5/openMiniProgram")
    },
    {
      path: "/openActivityRule",
      name: "打开活动页",
      component: () => import("@/views/h5/openActivityRule")
    },
    {
      path: "/a/:id",
      name: "活动短链",
      component: () => import("@/views/h5/openActivityRule")
    },
    {
      path: "/addWecom",
      name: "添加企业微信",
      component: () => import("@/views/h5/addWecom")
    },
    {
      path: "/lotteryDraw",
      name: "抽奖",
      component: () => import("@/views/h5/lotteryDraw/index")
    },
    {
      path: "/lotteryDrawDetail",
      name: "抽奖记录",
      component: () => import("@/views/h5/lotteryDraw/detail")
    },
    {
      path: "/processUpgrade",
      name: "施工工艺升级通知",
      component: () => import("@/views/h5/processUpgrade")
    },
    {
      path: "/longBrandActivity",
      name: "龙牌",
      component: () => import("@/views/activity/longBrandActivity")
    },
    {
      path: "/polyActivity",
      name: "保利",
      component: () => import("@/views/activity/polyActivity")
    },
    {
      path: "/informationServiceAgreement",
      name: "当家信息服务协议",
      component: () => import("@/views/h5/informationServiceAgreement")
    },
    {
      path: "/xiaohongshuMonitor",
      name: "",
      component: () => import("@/views/h5/xiaohongshuMonitor")
    },
    {
      path: "/faceRecognition",
      name: "",
      component: () => import("@/views/h5/faceRecognition")
    },
    {
      path: "/douyinTrafficDelivery",
      name: "当家找工长",
      component: () => import("@/views/h5/douyinTrafficDelivery")
    },
    {
      path: "/commitmentBook",
      name: "签署承诺书",
      component: () => import("@/views/h5/commitmentBook")
    },
    {
      path: "/couponActivity",
      name: "",
      component: () => import("@/views/activity/couponActivity")
    },
    {
      path: "/fangxinqian",
      name: "签署承诺书",
      component: () => import("@/views/h5/fangxinqian")
    },
    {
      path: "/noviceTask",
      name: "新手任务",
      component: () => import("@/views/activity/noviceTask/index")
    },
    {
      path: "/noviceTask/task",
      name: "新手任务",
      component: () => import("@/views/activity/noviceTask/task")
    },
    {
      path: "/noviceTask/reward",
      name: "提取奖励",
      component: () => import("@/views/activity/noviceTask/reward")
    },
    {
      path: "/noviceTask/rule",
      name: "活动规则",
      component: () => import("@/views/activity/noviceTask/rule")
    },
    {
      path: "/:shortCode(\\d)",
      name: "活动一位短链",
      component: () => import("@/views/h5/openActivityRule")
    },
  ]
});
